import styled from 'styled-components';

const LOGO = styled.div`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
`;
function VendxLogo() {
  return (
    <LOGO>
      <img src="/vendx-full.png" alt="logo" />
    </LOGO>
  );
}

export default VendxLogo;
